// Engelse teksten van de herinneringen op het bord (zie reminders.nl.ts).
export const kioskRemindersEn = {
    ok: 'OK!',
    /** Rustig, buiten het thema Kinderen. */
    okCalm: 'OK',
    speak: '{names}, {title}!',
    context: '{title} at {time}',
    hint: 'Soon: {title} · {time}',
    and: 'and',
    dialog: 'Reminder: {title}',
    okFor: 'OK, {name}',
    checklist: 'In the bag',
    checklistLeft: '{count} to go',
    checklistDone: 'All in!',
    checklistDoneCalm: 'Everything is packed',
    checklistItem: '{label}, {name}',
    checklistItemDone: '{label} is in',
    taskContext: 'Task at {time}',
};
//# sourceMappingURL=reminders.en.js.map